import { createApp, reactive, ref } from 'vue';
import App from './App.vue';

import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

import { VNumberInput } from 'vuetify/labs/VNumberInput'
import { VTreeview } from 'vuetify/labs/VTreeview'

import '@mdi/font/css/materialdesignicons.css';


import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap';

import { createRouter, createWebHistory } from 'vue-router'
import { createI18n } from 'vue-i18n';
import messages from './assets/messages.json'

import Vue3Toasity, { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import ToastService from './services/toastService';

// Home
import Home from './components/pages/Home.vue';

// Shop Admin Panel
import ShopHome from './components/shop/ShopHome.vue';
import ShopFavorites from './components/shop/ShopFavorites.vue';
import EditShopProfile from './components/shop/EditShopProfile.vue';
import Settings from './components/shop/Settings.vue';
import Password from './components/shop/Password.vue';
import Subscriptions from './components/shop/Subscriptions.vue';
import MapPage from './components/pages/MapPage.vue';

// Backoffice
import Shops from './components/backoffice/Shops.vue';
import RegisterShop from './components/backoffice/RegisterShop.vue';
import Admins from './components/backoffice/Admins.vue';
import PremiumFeatures from './components/backoffice/PremiumFeatures.vue';
import Users from './components/backoffice/Users.vue';
import UpgradeUsers from './components/backoffice/UpgradeUsers.vue';
import Brands from './components/backoffice/Brands.vue';
import Labels from './components/backoffice/Labels.vue';
import LabelCategories from './components/backoffice/LabelCategories.vue';
import ProductCategories from './components/backoffice/ProductCategories.vue';
import Attributes from './components/backoffice/Attributes.vue';
import Vouchers from './components/backoffice/Vouchers.vue';
import PushNotifications from './components/backoffice/PushNotifications.vue';
import AreaData from './components/backoffice/AreaData.vue';
import ProductGroups from './components/backoffice/ProductGroups.vue';


import { checkLoggedIn, resetAuthorization, hasRole, getPublicityState, isImpersonating } from '@/utils/auth';
import apiClients from './services/apiService';

// global import
import CustomIcon from './components/custom/CustomIcon.vue';
import CustomEmojiPicker from './components/custom/CustomEmojiPicker.vue';

// Error
import NotFound from './components/pages/error/NotFound.vue';

//fairling
import CompanyShopProfile from './components/shop/fairling/CompanyShopProfile.vue';
import CompanyProductProfile from './components/shop/fairling/CompanyProductProfile.vue';

import Login from './components/pages/Login.vue';
import ShopProfile from './components/shop/ShopProfile.vue';
import ShopImagesUpload from './components/shop/ShopImagesUpload.vue';

//utils
import Vue3Tour from 'vue3-tour'
import 'vue3-tour/dist/vue3-tour.css'

import { formatDate,formatDateWithoutDay, getTimeDuration, getMonthName, convertCentsToEuros, formatOpeningStatus, endsWith, getShortDay, replaceUmlauts } from './utils/utils';
import RetailersMap from './components/shop/fairling/RetailersMap.vue';
import PostPage from './components/pages/PostPage.vue';
import StreamCategories from './components/backoffice/StreamCategories.vue';
import ForgotPassword from './components/pages/ForgotPassword.vue';
import UserPosts from './components/backoffice/UserPosts.vue';







const router = createRouter({

    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: Home,
            redirect: (to) => {
                const isLoggedIn = checkLoggedIn();
                if (isLoggedIn && hasRole('ROLE_DEALER') && !hasRole('ROLE_ADMINISTRATOR')) {
                    // Redirect to shop home if logged in
                    return { path: '/shop/home', name: 'shopHome' };
                } else if (isLoggedIn && hasRole('ROLE_ADMINISTRATOR')) {
                    return { path: '/backoffice/shop', name: 'backoffice.shops' };
                } else {
                    // Redirect to city route (default city logic handled by the 'City' route)
                    const lastSelectedCity = localStorage.getItem('lastSelectedCity') || 'hamburg'; // Fallback to 'hamburg'
                    return { name: 'City', params: { city: lastSelectedCity } };
                }
            },
        },
        {
            path: '/:city',
            name: 'City',
            component: Home, // Replace with your city view component
            beforeEnter: async (to, from, next) => {
                const lastSelectedCity = localStorage.getItem('lastSelectedCity');

                if (!to.params.city) {
                    // If no city is provided, redirect to last selected city or fallback
                    const fallbackCity = lastSelectedCity || 'hamburg';
                    return next({ name: 'City', params: { city: fallbackCity } });
                }

                // If a city is provided, save it in localStorage and proceed
                localStorage.setItem('lastSelectedCity', to.params.city);
                next();
            },
        },
        { path: '/login', name: 'Login', component: Login },
        { path: '/passwordforgot', name: 'PasswordForgot', component: ForgotPassword },
        { path: '/:city/suche/:type/:value/', component: MapPage, props: true, },
        { path: '/:city/suche/:type/:value/:value', component: MapPage, props: true, },
        { path: '/:city/laden/:shop/neuigkeiten/:headline', component: PostPage, props: true, },
        { path: '/:city/user/:user/neuigkeiten/:headline', component: PostPage, props: true, },
        { path: '/:city/laden/:shop', name: 'ShopProfile', component: ShopProfile, query: { mode: 'all', lang: 'DE' } },
        { path: '/shop/home', name: 'shopHome', component: ShopHome, meta: { requiresAuth: true } },
        { path: '/settings', name: 'Settings', component: Settings, meta: { requiresAuth: true } },
        { path: '/password', name: 'Password', component: Password, meta: { requiresAuth: true } },
        { path: '/shop/assets', name: 'ShopImages', component: ShopImagesUpload, meta: { requiresAuth: true } },
        { path: '/shop/subscription', name: 'Subscriptions', component: Subscriptions, meta: { requiresAuth: true } },
        { path: '/shop/favorites', name: 'ShopFavorites', component: ShopFavorites, meta: { requiresAuth: true } },
        { path: '/shop/profile', name: 'EditShopProfile', component: EditShopProfile, meta: { requiresAuth: true }, props: (route) => ({ editMode: route.query.editMode || false }), },
        {
            path: '/fairling/:merchantId',
            name: 'RetailersMap',
            component: RetailersMap
        },
        {
            path: '/fairling/:merchantId/:id?',
            name: 'CompanyShopProfile',
            component: CompanyShopProfile
        },
        {
            path: '/fairling/:merchantId/', // Handle trailing slash
            redirect: (to) => {
                if (!endsWith(to.path, '/') && to.params.id == null) {
                    return { name: 'RetailersMap', params: { merchantId: to.params.merchantId } };
                } else if (endsWith(to.path, '/') || to.params.id != null) {
                    return { name: 'CompanyShopProfile', params: { merchantId: to.params.merchantId, id: null } };
                }
            }
        },
        { path: '/fairling/product-highlight/:id/:productId', name: 'CompanyProductProfile', component: CompanyProductProfile },
        // { path: '/fairling/:merchantId/', name: 'CompanyShopProfile', component: CompanyShopProfile },
        { path: '/404', name: 'NotFound', component: NotFound },
        // Backoffice Routes
        { path: '/backoffice/shop', name: 'backoffice.shops', component: Shops, meta: { requiresAuth: true } },
        { path: '/backoffice/register', name: 'backoffice.register', component: RegisterShop, meta: { requiresAuth: true } },
        { path: '/backoffice/admin', name: 'backoffice.masterdata.admins', component: Admins, meta: { requiresAuth: true } },
        { path: '/backoffice/manage-user', name: 'backoffice.manage-user', component: Users, meta: { requiresAuth: true } },
        { path: '/backoffice/userposts', name: 'backoffice.userPosts', component: UserPosts, meta: { requiresAuth: true } },
        { path: '/backoffice/premium-features', name: 'backoffice.premium-features', component: PremiumFeatures, meta: { requiresAuth: true } },
        { path: '/backoffice/brand', name: 'backoffice.masterdata.brands', component: Brands, meta: { requiresAuth: true } },
        { path: '/backoffice/upgrade-users', name: 'backoffice.upgrade-user', component: UpgradeUsers, meta: { requiresAuth: true } },
        { path: '/backoffice/label', name: 'backoffice.masterdata.labels', component: Labels, meta: { requiresAuth: true } },
        { path: '/backoffice/labelcategory', name: 'backoffice.masterdata.labelcategory', component: LabelCategories, meta: { requiresAuth: true } },
        { path: '/backoffice/streamcategory', name: 'backoffice.masterdata.streamcategory', component: StreamCategories, meta: { requiresAuth: true } },
        { path: '/backoffice/productcategory', name: 'backoffice.masterdata.productcategory', component: ProductCategories, meta: { requiresAuth: true } },
        { path: '/backoffice/attribute', name: 'backoffice.masterdata.attribute', component: Attributes, meta: { requiresAuth: true } },
        { path: '/backoffice/voucher', name: 'backoffice.voucher', component: Vouchers, meta: { requiresAuth: true } },
        { path: '/backoffice/pushnotifications', name: 'backoffice.masterdata.pushnotifications', component: PushNotifications, meta: { requiresAuth: true } },
        { path: '/backoffice/country', name: 'backoffice.masterdata.country', component: AreaData, meta: { requiresAuth: true } },
        { path: '/backoffice/productgroup', name: 'backoffice.masterdata.productgroup', component: ProductGroups, meta: { requiresAuth: true } },

    ],
});

// Add a navigation guard
router.beforeEach((to, from, next) => {
    const isLoggedIn = checkLoggedIn();
    console.log('IsLoggedIn', isLoggedIn)
    console.log('to', to)
    if (to.path === '/') {
        // Redirect based on login status
        if (isLoggedIn) {
            next({ name: 'shopHome' }); // Redirect to ShopHome if logged in
        } else if (hasRole('ROLE_ADMINISTRATOR')) {
            next({ name: 'backoffice.shops' })
        } else {
            next(); // Proceed to Home if not logged in
        }
    }
    else if (to.meta.requiresAuth && !isLoggedIn) {
        // Redirect to login if not logged in
        next({ name: "Login" });
    } else {
        // Proceed as normal
        console.log("Proceed as normal")
        next();
    }
});

// Function to check if user is logged in


const vuetify = createVuetify({
    components: {
        ...components,  // Spread all Vuetify components
        VNumberInput,    // Register VNumberInput separately
        VTreeview
    },
    directives,
    theme: {
        themes: {
            light: {
                dark: false,
                colors: {
                    // primary: '#5bc0de', // #005BAC
                    primary: '#19CBEF',
                    'on-primary': '#ffffff',
                    secondary: '#34a4bf',
                    default: '#f5f5f5',
                    error: '#D50000'
                }
            },
        },
    },
});

const i18n = createI18n({
    locale: localStorage.getItem('selectedLanguage'), // Set the default locale
    fallbackLocale: 'de', // Fallback locale in case the translation is missing
    messages, // Set the locale messages
});

const initializeScreenWidth = () => {
    console.log('initializeScreenWidth', window.innerWidth)
    if (window.innerWidth >= 1920) {
        return 'xl';
    } else if (window.innerWidth >= 1264) {
        return 'lg';
    } else if (window.innerWidth >= 960) {
        return 'md';
    } else if (window.innerWidth >= 600) {
        return 'sm';
    } else {
        return 'xs';
    }
    // console.log(app.config.globalProperties.$screenWidth);
}

const globalState = reactive({
    screenWidth: initializeScreenWidth()
});
const updateScreenWidth = () => {
    // console.log('resized');
    globalState.screenWidth = initializeScreenWidth();
}

window.addEventListener('resize', () => {
    updateScreenWidth();
});

const app = createApp(App);

app.use(Vue3Tour)

const impersonatingFlag = sessionStorage.getItem('impersonating');
if (impersonatingFlag === 'true') {
  isImpersonating.value = true;
}

app.config.globalProperties.$globalState = globalState;
app.config.globalProperties.$toast = ToastService;
app.config.globalProperties.$checkLoggedIn = checkLoggedIn;
app.config.globalProperties.$hasRole = (role) => hasRole(role);
app.config.globalProperties.$getPublicityState = getPublicityState;
app.config.globalProperties.$resetAuthorization = resetAuthorization;
app.config.globalProperties.$axios = apiClients.default; // Default client
app.config.globalProperties.$authAxios = apiClients.auth; // Auth client
app.config.globalProperties.$dataAxios = apiClients.data;
app.config.globalProperties.$cloudFrontApi = process.env.VUE_APP_CLOUDFRONT_BASE_URL;
app.config.globalProperties.$cloudFrontAssets = process.env.VUE_APP_CLOUDFRONT_ASSET_URL;
app.config.globalProperties.$vimeoUrl = process.env.VUE_APP_VIMEO_BASE_URL;
app.config.globalProperties.$user = ref(null);
app.config.globalProperties.$getTimeDuration = (timestamp) => getTimeDuration(timestamp, i18n.global.t);
app.config.globalProperties.$formatDate = (timestamp) => formatDate(timestamp, i18n.global.locale);
app.config.globalProperties.$formatDateWithoutDay = (timestamp) => formatDateWithoutDay(timestamp, i18n.global.locale);
app.config.globalProperties.$formatOpeningStatus = (openingStatus) => formatOpeningStatus(openingStatus, i18n.global.t);
app.config.globalProperties.$getMonthName = (monthIndex) => getMonthName(monthIndex, i18n.global.locale)
app.config.globalProperties.$getShortDay = (day) => getShortDay(day, i18n.global.locale.toUpperCase())
app.config.globalProperties.$replaceUmlauts = (str) => replaceUmlauts(str);
app.config.globalProperties.$convertCentsToEuros = (cents) => convertCentsToEuros(cents, i18n.global.locale)

window.vueApp = app;
// app.provide('toast', toast);
// app.use(Vue3Toasity, {
//     autoClose: 3000,  // Auto close duration (in ms)
//     position: "top", // Toast position
//     transition: "bounce",  // Animation type
//     theme: "dark",  // Theme: "light", "dark", "colored"
//     multiple: true,  // Allow multiple toasts
//     pauseOnHover: true, // Pause when hovering
//     dangerouslyHTMLString: true, // Allow HTML in messages
//     closeButton: false, // Show close button
// });


app.component('CustomEmojiPicker', CustomEmojiPicker).component('CustomIcon', CustomIcon).use(vuetify).use(router).use(i18n).mount('#app');
